import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetValuationByIdDTO } from '../patent-repository';
import type { PatentValuationEntity } from '../../types';

export const PatentValuationService = Symbol('PatentValuationService');

export interface PatentValuationService {
    getValuation(patentId: string): Promise<PatentValuationEntity>;
}

@injectable()
export class PatentValuationServiceImpl implements PatentValuationService {
    private _cache = new Map<string, PatentValuationEntity>();

    constructor(
        @inject(GetValuationByIdDTO)
        private _getValuationByIdDTO: GetValuationByIdDTO,
    ) {
    }

    private _setEntityCache(patentId: string, data: PatentValuationEntity) {
        this._cache.set(patentId, data);
    }

    private _getEntityCache(patentId: string) {
        return this._cache.get(patentId);
    }

    public async getValuation(patentId: string) {
        const cacheData = this._getEntityCache(patentId);

        if (cacheData) {
            return cacheData;
        } else {
            const data = await this._getValuationByIdDTO.getValuationById(patentId);
            this._setEntityCache(patentId, data);
            return data;
        }
    }
}

